/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesWebhooksApplicationSubscriptionsTestTestSubscriptionResult } from '../model/modulesWebhooksApplicationSubscriptionsTestTestSubscriptionResult';
import { ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse } from '../model/modulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse';
import { ModulesWebhooksApplicationTypeConfigurationsWebhookTypeConfigurationResponse } from '../model/modulesWebhooksApplicationTypeConfigurationsWebhookTypeConfigurationResponse';
import { ModulesWebhooksDomainWebhookSubscriptionsWebhookType } from '../model/modulesWebhooksDomainWebhookSubscriptionsWebhookType';
import { ModulesWebhooksEndpointsContractsCreateSubscriptionRequest } from '../model/modulesWebhooksEndpointsContractsCreateSubscriptionRequest';
import { ModulesWebhooksEndpointsContractsUpdateSubscriptionRequest } from '../model/modulesWebhooksEndpointsContractsUpdateSubscriptionRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { WebhooksServiceInterface }                            from './webhooks.serviceInterface';


@Injectable()
export class WebhooksService implements WebhooksServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a webhook subscription by ID.
     * Gets a webhook subscription by ID.
     * @param subscriptionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSubscriptionByIdEndpoint(subscriptionId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse>;
    public getSubscriptionByIdEndpoint(subscriptionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse>>;
    public getSubscriptionByIdEndpoint(subscriptionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse>>;
    public getSubscriptionByIdEndpoint(subscriptionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (subscriptionId === null || subscriptionId === undefined) {
            throw new Error('Required parameter subscriptionId was null or undefined when calling getSubscriptionByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse>('get',`${this.basePath}/webhooks/subscriptions/${encodeURIComponent(String(subscriptionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all webhook subscriptions.
     * Gets all webhook subscriptions.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSubscriptionsEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse>>;
    public getSubscriptionsEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse>>>;
    public getSubscriptionsEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse>>>;
    public getSubscriptionsEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesWebhooksApplicationSubscriptionsWebhookSubscriptionResponse>>('get',`${this.basePath}/webhooks/subscriptions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a webhook subscription.
     * Creates a webhook subscription.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhooksSubscriptionsPost(body?: ModulesWebhooksEndpointsContractsCreateSubscriptionRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public webhooksSubscriptionsPost(body?: ModulesWebhooksEndpointsContractsCreateSubscriptionRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public webhooksSubscriptionsPost(body?: ModulesWebhooksEndpointsContractsCreateSubscriptionRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public webhooksSubscriptionsPost(body?: ModulesWebhooksEndpointsContractsCreateSubscriptionRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/webhooks/subscriptions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a webhook subscription.
     * Deletes a webhook subscription.
     * @param subscriptionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhooksSubscriptionsSubscriptionIdDelete(subscriptionId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public webhooksSubscriptionsSubscriptionIdDelete(subscriptionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public webhooksSubscriptionsSubscriptionIdDelete(subscriptionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public webhooksSubscriptionsSubscriptionIdDelete(subscriptionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (subscriptionId === null || subscriptionId === undefined) {
            throw new Error('Required parameter subscriptionId was null or undefined when calling webhooksSubscriptionsSubscriptionIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/webhooks/subscriptions/${encodeURIComponent(String(subscriptionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a webhook subscription.
     * Updates a webhook subscription.
     * @param subscriptionId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhooksSubscriptionsSubscriptionIdPut(subscriptionId: string, body?: ModulesWebhooksEndpointsContractsUpdateSubscriptionRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public webhooksSubscriptionsSubscriptionIdPut(subscriptionId: string, body?: ModulesWebhooksEndpointsContractsUpdateSubscriptionRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public webhooksSubscriptionsSubscriptionIdPut(subscriptionId: string, body?: ModulesWebhooksEndpointsContractsUpdateSubscriptionRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public webhooksSubscriptionsSubscriptionIdPut(subscriptionId: string, body?: ModulesWebhooksEndpointsContractsUpdateSubscriptionRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (subscriptionId === null || subscriptionId === undefined) {
            throw new Error('Required parameter subscriptionId was null or undefined when calling webhooksSubscriptionsSubscriptionIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/webhooks/subscriptions/${encodeURIComponent(String(subscriptionId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sends a test webhook to a subscription.
     * Sends a synthetic test payload to the subscription&#x27;s endpoint URL and returns the delivery result including HTTP status code, response body, and elapsed time.
     * @param subscriptionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhooksSubscriptionsSubscriptionIdTestPost(subscriptionId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesWebhooksApplicationSubscriptionsTestTestSubscriptionResult>;
    public webhooksSubscriptionsSubscriptionIdTestPost(subscriptionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesWebhooksApplicationSubscriptionsTestTestSubscriptionResult>>;
    public webhooksSubscriptionsSubscriptionIdTestPost(subscriptionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesWebhooksApplicationSubscriptionsTestTestSubscriptionResult>>;
    public webhooksSubscriptionsSubscriptionIdTestPost(subscriptionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (subscriptionId === null || subscriptionId === undefined) {
            throw new Error('Required parameter subscriptionId was null or undefined when calling webhooksSubscriptionsSubscriptionIdTestPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesWebhooksApplicationSubscriptionsTestTestSubscriptionResult>('post',`${this.basePath}/webhooks/subscriptions/${encodeURIComponent(String(subscriptionId))}/test`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all webhook type configurations.
     * Returns the enabled/disabled status for each webhook type.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhooksTypesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesWebhooksApplicationTypeConfigurationsWebhookTypeConfigurationResponse>>;
    public webhooksTypesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesWebhooksApplicationTypeConfigurationsWebhookTypeConfigurationResponse>>>;
    public webhooksTypesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesWebhooksApplicationTypeConfigurationsWebhookTypeConfigurationResponse>>>;
    public webhooksTypesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesWebhooksApplicationTypeConfigurationsWebhookTypeConfigurationResponse>>('get',`${this.basePath}/webhooks/types`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Disables a webhook type.
     * Disables the specified webhook type so integration events for it will be ignored.
     * @param webhookType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhooksTypesWebhookTypeDisablePut(webhookType: ModulesWebhooksDomainWebhookSubscriptionsWebhookType, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public webhooksTypesWebhookTypeDisablePut(webhookType: ModulesWebhooksDomainWebhookSubscriptionsWebhookType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public webhooksTypesWebhookTypeDisablePut(webhookType: ModulesWebhooksDomainWebhookSubscriptionsWebhookType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public webhooksTypesWebhookTypeDisablePut(webhookType: ModulesWebhooksDomainWebhookSubscriptionsWebhookType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (webhookType === null || webhookType === undefined) {
            throw new Error('Required parameter webhookType was null or undefined when calling webhooksTypesWebhookTypeDisablePut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put',`${this.basePath}/webhooks/types/${encodeURIComponent(String(webhookType))}/disable`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Enables a webhook type.
     * Enables the specified webhook type so integration events for it will trigger webhooks.
     * @param webhookType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhooksTypesWebhookTypeEnablePut(webhookType: ModulesWebhooksDomainWebhookSubscriptionsWebhookType, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public webhooksTypesWebhookTypeEnablePut(webhookType: ModulesWebhooksDomainWebhookSubscriptionsWebhookType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public webhooksTypesWebhookTypeEnablePut(webhookType: ModulesWebhooksDomainWebhookSubscriptionsWebhookType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public webhooksTypesWebhookTypeEnablePut(webhookType: ModulesWebhooksDomainWebhookSubscriptionsWebhookType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (webhookType === null || webhookType === undefined) {
            throw new Error('Required parameter webhookType was null or undefined when calling webhooksTypesWebhookTypeEnablePut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put',`${this.basePath}/webhooks/types/${encodeURIComponent(String(webhookType))}/enable`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
